exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-download[data-v-0196943b]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;gap:8px}.btn-delete[data-v-0196943b],.btn-download[data-v-0196943b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.btn-delete[data-v-0196943b]{width:18px;height:18px;border:1px solid #ddd;border-radius:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.btn-delete i[data-v-0196943b]{font-size:13px}.btn-delete[data-v-0196943b]:hover{background-color:#f5f5f5}td[data-v-0196943b]{word-break:break-all}", ""]);

// exports
